/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Uno_Edu_Chat_Input_Chip1_AnswerInputs */



/**
* | output |
* | --- |
* | "Ask anything in plain language. You can @-mention project files and spaces, upload files for this chat, pick the AI model, and use voice input instead of typ..." |
*
* @param {Uno_Edu_Chat_Input_Chip1_AnswerInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const uno_edu_chat_input_chip1_answer = /** @type {((inputs?: Uno_Edu_Chat_Input_Chip1_AnswerInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uno_Edu_Chat_Input_Chip1_AnswerInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Fragen Sie alles in natürlicher Sprache. Sie können Projektdateien und Spaces mit @ erwähnen, Dateien für diesen Chat hochladen, das KI-Modell wählen und Spracheingabe statt Tippen nutzen.")
	return /** @type {LocalizedString} */ ("Ask anything in plain language. You can @-mention project files and spaces, upload files for this chat, pick the AI model, and use voice input instead of typing.")
});